import { createRouter, createWebHistory } from 'vue-router'
import Main from '../views/Main.vue'
import LoginScreen from '../views/LoginScreen.vue'

const routes = [
  {
    path: '/app',
    name: 'Main',
    component: Main
  },
  {
    path: '/login',
    name: 'LoginScreen',
    component: LoginScreen
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
